import { useState, useEffect } from 'react';
import AdminSidebar, { AdminTab } from './AdminSidebar';
import AdminHeader from './AdminHeader';

const tabTitles: Record<AdminTab, { title: string; subtitle?: string }> = {
  overview: { title: 'Overview', subtitle: 'Platform performance at a glance' },
  users: { title: 'User Management', subtitle: 'All platform accounts' },
  usage: { title: 'AI & Usage', subtitle: 'Resource consumption monitoring' },
  payments: { title: 'Payments', subtitle: 'Transaction lifecycle' },
  health: { title: 'System Health', subtitle: 'Infrastructure status' },
  broadcast: { title: 'Broadcast Emails', subtitle: 'Email campaigns' },
};

interface AdminLayoutProps {
  activeTab: AdminTab;
  onTabChange: (tab: AdminTab) => void;
  children: React.ReactNode;
}

const AdminLayout = ({ activeTab, onTabChange, children }: AdminLayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const { title, subtitle } = tabTitles[activeTab] || { title: 'Admin' };

  // Close sidebar on mobile when resizing to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="admin-shell bg-background text-foreground min-h-screen">
      <AdminSidebar
        activeTab={activeTab}
        onTabChange={onTabChange}
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <AdminHeader
        title={title}
        subtitle={subtitle}
        onMenuClick={() => setSidebarOpen(true)}
      />

      {/* Main Content */}
      <main className="lg:ml-[260px] pt-16 min-h-screen transition-all duration-300">
        <div className="p-4 sm:p-6">
          <div className="max-w-7xl mx-auto space-y-6">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
